import React, { useEffect, useRef, useState } from 'react'
import TopBar from './TopBar'
import {Dialog, IconButton, Skeleton, Tooltip} from '@mui/material'
import HomeIcon from '@mui/icons-material/Home';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../../../../Redux/store';
import { setBtnSelected, setCustomer } from './topBarSliceBilling';
import dummyProductItemImg from "../../../../../Assets/BillingImages/emptyFoodImg.svg"
import { setBillLoading, setDialogBox, setErrorSnack, setOrderIdInPOS, setSingleOrderInfo, setSnackMsg } from '../Slice/billingScreenSlice';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import FilterButton from '../Utilities/FilterButton';
import { setApplyBtnClicked, setFilteredOrderType, setStatusOptions } from '../Utilities/filterButtonSlice';
import { cancelOngoingOrderApiCall, cancelAllOngoingOrdersApiCall, deleteBookingOrder, listHeldOrders, listOrdersForBillingAPI, listOrdersPaginationAPI } from '../API/viewOrderSection';
import TimerColumn from '../Utilities/TimerColumn';
import HeldOrderGridView from './HeldOrderGridView';
import { convertDateFormat, convertMonthFormat } from '../../../../../Js/Date';
import emptyOrderImg from ".././image/emptyOrder.png"
import BackspaceIcon from '@mui/icons-material/Backspace';
import { setPageIndexForViewOrder, setPaginationForViewOrder } from '../Slice/viewOrdersBillingSlice';
import LinearLoading from '../Utilities/LinearLoading';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { PrintOutlined } from "@mui/icons-material";
import PosReceiptTemplate from '../../../components/template/posReceipt/PosReceiptTemplate';
import { getInvoiceReceipt } from '../API/billingPaymentSection';
import { sendMessageToWhatsApp } from '../newBillingAPI';
import  html2pdf  from 'html2pdf.js';
import { setSubmitLoading } from '../../../../../Redux/Dashboard/mainDashBoardSlice';
import KOTorders from '../Utilities/KOTorders';
import Swal from 'sweetalert2';
import { pdfBlobOptionsPrint } from '../../../../Single Components/GneralUtilities';
import { printRequestAPICall } from '../../../Settings/Device Settings/deviceSettingsAPI';
import { getPPI, numToWords, urlToBlob } from '../../../../../Js/generalFunctions';
import db from '../../../../../offline/db';
import UpdateOrderAuth from './UpdateOrderAuth';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { errorSnackMsg } from '../../../../Custom Hooks/SnackkBarUtilities';
import PosOrdersHeader from '../../../PointOfSale/General/Order/PosOrdersHeader';

function ViewOrders() {

const dispatch=useDispatch()
let invoicePrint = useRef();
const [printKey, setPrintKey] = useState(Date.now());
const [receiptPreviewOpen, setReceiptPreviewOpen] = useState(false);

const decimalPosition=localStorage.getItem("decimalPosition")
const userInfo = useSelector((state) => state.loginResponseSlice.value);

// redux states
const {ordersList,tableLoading,cartLoading,heldOrders,pageIndex,pagination,receiptData}=useSelector((state)=>state.viewOrdersBillingSlice)
const {singleOrderInfo,orderIdForPos,dialogOpen}=useSelector((state)=>state.billingScreenSlice)

// Debug receiptData
useEffect(() => {
  console.log("ViewOrders - receiptData from Redux:", receiptData);
}, [receiptData]);
const {btnClicked,searchBarInput}=useSelector((state)=>state.topBarSliceBilling)
const { authPassWord,branchConfigurationList } = useSelector((state) => state.newBillingSlice);
const {filteredOrderType,filteredStatus,applyBtnClicked}=useSelector((state)=>state.filterButtonSlice)
const companyProfileData =useSelector((state) => state?.companyProfileSlice?.userValue)
// console.log(singleOrderInfo,"singleOrderInfo")
    const { posTemplateSelected } = useSelector((state) => state.posReceiptSlice);
    const branchSettingsView = useSelector((state) => state?.branchSettingsSliceNew?.rowData);

const paginationLoading=useSelector((state)=>state.mainDashBoardSlice.tableLoading)
const {currencyDetails}=useSelector((state)=>state.mainDashBoardSlice)

const [switchTabs,setSwitchTabs]=useState(["All","Dine In","Take Away","Delivery"])
//   useStates
const [cartItems, setCartItems] = useState([]);
const qtyViewOrderRefs=useRef((cartItems || []).map(() => React.createRef()));
const priceViewOrderRefs=useRef((cartItems || []).map(() => React.createRef()));
const [input, setInput] = useState('');
const [selectedCartRow,setSelectedCartRow]=useState(null)
const [inputSelection,setInputSelection]=useState(null)
const [isCartModified,setIsCartModified]=useState(false)
const [orderHistory,setOrderHistory]=useState([])
const [gridView,setGridView]=useState(btnClicked==="heldOrder")
const [billTypeOption, setBillTypeOption] = useState("All");
const [viewOrderSingleId, setViewOrderSingleId] = useState(null);
const [currentTime, setCurrentTime] = useState(new Date());

// pagination
const handleScroll = (e) => {
  const { scrollTop, clientHeight, scrollHeight } = e.target;
  if (scrollTop + clientHeight+100 >= scrollHeight) {

    if (btnClicked==="viewOrder" && orderHistory?.length >= 30 && !paginationLoading && pagination !== "max") {
      dispatch(setPageIndexForViewOrder(pageIndex + 1));
      dispatch(setPaginationForViewOrder(true));
    }
  }
};
// view order single row click

const viewOrderSingleClick=(row)=>()=>{
  console.log("Order clicked, fetching invoice for orderId:", row?._id);
  dispatch(setOrderIdInPOS(row?._id))
  getInvoiceReceipt({orderId:row?._id})
}

const ensureReceiptDataLoaded = async (orderId) => {
  if (!orderId) return;
  if (!receiptData || !receiptData._id || receiptData._id !== orderId) {
    await getInvoiceReceipt({ orderId });
    let attempts = 0;
    while (attempts < 20) {
      await new Promise(resolve => setTimeout(resolve, 200));
      const currentReceiptData = store.getState().viewOrdersBillingSlice.receiptData;
      if (currentReceiptData && currentReceiptData._id === orderId) {
        break;
      }
      attempts++;
    }
  }
};

const openReceiptPreview = async () => {
  dispatch(setBillLoading(true));
  try {
    await ensureReceiptDataLoaded(orderIdForPos);
    setPrintKey(Date.now());
    setReceiptPreviewOpen(true);
  } finally {
    dispatch(setBillLoading(false));
  }
}
const singleViewOrderGeneral=(row)=>(e)=>{
  e.stopPropagation(); 
  if (row?.status === "POSTED" || row?.status === "DONE"){
      setViewOrderSingleId(row?._id)
  }
}

// keypad onChange
const handleButtonClick = (value) => {
  if(selectedCartRow!==null){
    const updatedCartItems = [...cartItems];
    const updatedCartItem = { ...updatedCartItems[selectedCartRow] };
    
    if(inputSelection==="qty"){
      if(updatedCartItem?.qty<Number(input+value)){
        dispatch(setSnackMsg("Return quantity is greater than order quantity !!"))
        dispatch(setErrorSnack(true))
      }else{
          setInput((prevInput) => prevInput + value);
          updatedCartItem.retQty = Number(input+value);
        }
      }else if(inputSelection==="price"){
        setInput((prevInput) => prevInput + value);
        updatedCartItem.unitPrice = Number(input+value);
      }

      updatedCartItems[selectedCartRow] = updatedCartItem;
      
      setCartItems(updatedCartItems);
      setIsCartModified(!isCartModified)
    
  }
};

const keyPadBacksPace=()=>{
  if(input!==""){
    const updatedCartItems = [...cartItems];
    const updatedCartItem = { ...updatedCartItems[selectedCartRow] };
    if(inputSelection==="qty"){
      updatedCartItem.retQty = Number(input.slice(0, -1));
    }else if(inputSelection==="price"){
      updatedCartItem.unitPrice = Number(input.slice(0, -1));
    }
    updatedCartItems[selectedCartRow] = updatedCartItem;
    setCartItems(updatedCartItems);
    setIsCartModified(!isCartModified)
    setInput(input.slice(0, -1));
  }
}
// refund button onclick
const finalPlaceOrder = () => {
    if(singleOrderInfo?.status==="RETURN"){
      let subTotal=singleOrderInfo?.subTotal
      let amtTotal=Math.abs(singleOrderInfo?.amountDue)
      let totalExclusive=singleOrderInfo?.totalExclusive
      let totalInclusive=singleOrderInfo?.totalInclusive
      
      let payload={
        mainOrdId:singleOrderInfo?._id,
        branchId:singleOrderInfo?.branchId,
        cusId: singleOrderInfo?.cusId,
        orderInfo:cartItems,
        subTotal,
        discountAmt: 0,
        totalExclusive,
        totalInclusive,
        amtTotal,
        type:"refund",
        status:singleOrderInfo?.status
      }

    dispatch(setSingleOrderInfo(payload))

    }
    dispatch(setBtnSelected("payment"))
};

const viewOrderUpdateOrder=()=>{

  if(btnClicked==="viewOrder"){
    dispatch(setBtnSelected(null))
    dispatch(setOrderIdInPOS(null))
  }else{
    dispatch(setBtnSelected(null))
  }
}
// input the changes of quantity from cart
const cartQuantityChange = (index, type) => (e) => {
  setInput("");
  const updatedCartItems = [...cartItems];
  const updatedCartItem = { ...updatedCartItems[index] };
  console.log("e", e.target.value);
  // console.log("updatedCartItem", updatedCartItem);
  if(type==="retQty"){
      if(updatedCartItem?.qty<Number(e.target.value)){
        dispatch(setSnackMsg("Return quantity is greater than order quantity !!"))
        dispatch(setErrorSnack(true))
      }else{
        updatedCartItem[type] = Number(e.target.value);
      }
  }else{
    updatedCartItem[type] = Number(e.target.value);
  }

  updatedCartItems[index] = updatedCartItem;
  setCartItems(updatedCartItems);
  setIsCartModified(!isCartModified)
};
// qty,price,note button
const keyPadTypeSelection=(key,index)=>{
  // setInput("")
  if(key==="qty"){
    let retQty=cartItems[index || selectedCartRow]?.retQty?.toString()
    setInput(retQty|| "")
  }else if(key==="price"){
    setInput(cartItems[index || selectedCartRow]?.unitPrice?.toString())
  }else{
    setInput("")
  }
  setInputSelection(key)
  const inputRef = key==="qty"?qtyViewOrderRefs.current[index || selectedCartRow]:key==="price"?priceViewOrderRefs.current[selectedCartRow]:null

  if (inputRef && inputRef.current) {
    const originalType = inputRef.current.type;
    inputRef.current.type = "text";

    inputRef.current.focus();

    setTimeout(() => {
      try {
        inputRef.current.setSelectionRange(
          inputRef.current.value.length,
          inputRef.current.value.length
        );
      } catch (e) {
        // number inputs don't support setSelectionRange
      }
      inputRef.current.type = originalType;
    }, 0);
  }

  if(key==="note"){
    dispatch(setDialogBox("addNote"))
  }
}
// cart row 
const cartRowClick=(index)=>{
  setSelectedCartRow(index===selectedCartRow?null:index)
  if(index===selectedCartRow){
    setInputSelection(null) 
  }else{
    keyPadTypeSelection("qty",index)
  }
}
const calculateAndSetCalculatedValues = () => {
  const calculatedValues = cartItems?.map((row) => {
    if (row?.retQty && Number(row.retQty) > 0) {

      let totalAmt = Number(row?.retQty) * Number(row?.unitPrice);
      let subtotalBeforeTax = totalAmt.toFixed(decimalPosition);
      let totalTax = row?.taxes?.reduce((sum, item) => sum + item?.amount, 0);
      let totalExclTax = (subtotalBeforeTax * totalTax) / 100;

      if (row?.includedPrice === "true" || row?.includedPrice === true) {
        let totalIncl=(Number(subtotalBeforeTax) * totalTax) / (100+totalTax)

        return { ...row, inclusiveTax: totalIncl, exclusiveTax: 0, subTotalWoTax: totalAmt, lineTotal: totalAmt };
      } else if (row?.includedPrice === "false" || row?.includedPrice === false) {
        return { ...row, exclusiveTax: totalExclTax, inclusiveTax: 0, subTotalWoTax: totalAmt, lineTotal: totalAmt + totalExclTax };
      } else {
        let totalAmt = Number(row?.retQty) * Number(row?.unitPrice);
        return { ...row, exclusiveTax: 0, inclusiveTax: 0, subTotalWoTax: totalAmt, lineTotal: totalAmt };
      }
    } else {
      // If returnQty is not defined or not greater than 0, return the original row
      return row;
    }
  });
  setCartItems(calculatedValues);
};

const disableCompleteOrder=(singleOrderInfo?.status==="DONE" || singleOrderInfo?.status==="POSTED")
// refund button Clicked
const returnQtyOrderInfo=cartItems?.map((item)=>(
  item?.qty>0 && item?.retQty && item?.retQty>0 &&
  {
    productId:item?.productId,
    desccription:item?.desccription,
    customerNote:item?.customerNote,
    qty: -(item?.retQty),
    uom:item?.uom,
    unitPrice:item?.unitPrice,
    subTotalWoTax: -(item?.subTotalWoTax),
    lineTotal: -(item?.lineTotal),
    taxes: item?.taxes,
    exclusiveTax:item?.exclusiveTax,
    inclusiveTax:item?.inclusiveTax,
    itemType:item?.itemType,
    includedPrice:(item?.includedPrice==="true" || item?.includedPrice===true)?true:(item?.includedPrice==="false" || item?.includedPrice===false)?false:null
}
)).filter(Boolean)

const clickRefund=()=>{


  let subTotal=returnQtyOrderInfo?.reduce((sum,item)=>sum + -(item?.subTotalWoTax),0)
  let amtTotal=returnQtyOrderInfo?.reduce((sum,item)=>sum + -(item?.lineTotal),0)
  let totalExclusive=returnQtyOrderInfo?.reduce((sum,item)=>sum + item?.exclusiveTax,0)
  let totalInclusive=returnQtyOrderInfo?.reduce((sum,item)=>sum + item?.inclusiveTax,0)

  let totalReturnQtyNos=returnQtyOrderInfo?.reduce((sum,item)=>sum + -(item?.qty),0)
  let totalQtyNos=cartItems?.reduce((sum,item)=>sum + (item?.originalQty),0)
  let discountedRate=singleOrderInfo?.discountAmt

  let discountPerQty=discountedRate/totalQtyNos

  let discountAmount=totalReturnQtyNos*discountPerQty

  
  let payload={
    mainOrdId:singleOrderInfo?._id,
    branchId:singleOrderInfo?.branchId,
    orderInfo:returnQtyOrderInfo,
    cusId: singleOrderInfo?.cusId,
    subTotal,
    discountAmt: Number(discountAmount),
    totalExclusive,
    totalInclusive,
    amtTotal,
    type:"refund"
  }

  if(returnQtyOrderInfo.length===0){
    dispatch(setSnackMsg("No items selected to return!!"))
    dispatch(setErrorSnack(true))
  }else{
    dispatch(setSingleOrderInfo(payload))
    dispatch(setBtnSelected("payment"))
  }
}

// filter order type onChange
const onChangeBillType=(key)=>()=>{
  let option=key==="Dine In"?"DINEIN":key==="Take Away"?"TAKEAWAY":key==="All"?null:"DELIVERY"
  setBillTypeOption(key)
  dispatch(setFilteredOrderType(option))
  dispatch(setApplyBtnClicked("clicked"))
  dispatch(setOrderIdInPOS(null))
}


const posReceiptPrint = async () => {
  console.log('Starting html2pdf print');
  if (!invoicePrint.current) return;

  // Ensure content exists
  let tries = 0;
  while (tries < 20) {
    const node = invoicePrint.current?.querySelector('.pos-receipt-template-container');
    if (node) break;
    await new Promise(r => setTimeout(r, 100));
    tries++;
  }

  // Temporarily reveal container to avoid zero-size capture
  const printParent = invoicePrint.current?.closest('.print-parent');
  const prev = printParent ? {
    position: printParent.style.position,
    top: printParent.style.top,
    left: printParent.style.left,
    width: printParent.style.width,
    maxHeight: printParent.style.maxHeight,
    overflow: printParent.style.overflow,
    opacity: printParent.style.opacity,
    zIndex: printParent.style.zIndex,
  } : null;
  if (printParent) {
    printParent.style.position = 'absolute';
    printParent.style.top = '0';
    printParent.style.left = '-9999px';
    // Don't change width - preserve receipt size
    printParent.style.maxHeight = 'none';
    printParent.style.overflow = 'visible';
    printParent.style.opacity = '1';
    printParent.style.zIndex = 'auto';
  }

  // Compute dynamic height for jsPDF
  const receiptHTML = invoicePrint.current;
  const ppi = getPPI();
  const pixelsToMM = (px) => px * (25.4 / ppi);
  const contentHeightMM = pixelsToMM(receiptHTML.offsetHeight) * 1.1; // small buffer

  let printSettingsString=localStorage.getItem('PrinterSettings')
  let printSettings=JSON.parse(printSettingsString || '{}')
  const paperWidth = Number(printSettings?.receiptSize || 80); // 80 or 58

  const opt = {
    margin: 0,
    html2canvas: { scale: 3, useCORS: true, backgroundColor: '#ffffff' },
    jsPDF: { unit: 'mm', format: [paperWidth, Math.max(contentHeightMM, 60)] }
  };

  try {
    const pdfBlob = await html2pdf().from(receiptHTML).set(opt).outputPdf('blob');
    const url = URL.createObjectURL(pdfBlob);
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);
    iframe.src = url;
    iframe.onload = () => {
      const cw = iframe.contentWindow;
      if (!cw) return;
      const cleanup = () => {
        try { URL.revokeObjectURL(url); } catch (_) {}
        try { document.body.removeChild(iframe); } catch (_) {}
        // Clean up temporary logo data URL
        delete window.__receiptLogoDataUrl;
        console.log('Print completed (cleanup)');
      };

      // Prefer afterprint to know user finished interacting with dialog
      cw.onafterprint = () => {
        cleanup();
        cw.onafterprint = null;
      };

      // Some browsers support matchMedia('print')
      try {
        const mql = cw.matchMedia ? cw.matchMedia('print') : null;
        if (mql && mql.addListener) {
          mql.addListener((e) => {
            if (!e.matches) {
              // Print dialog closed
              cleanup();
              try { mql.removeListener(); } catch (_) {}
            }
          });
        }
      } catch (_) {}

      // Final failsafe: very long timeout (does not interrupt user changing destination)
      const failSafe = setTimeout(() => {
        cleanup();
      }, 30000);

      // Hook cleanup into afterprint too
      const originalAfterPrint = cw.onafterprint;
      cw.onafterprint = () => {
        clearTimeout(failSafe);
        if (originalAfterPrint) try { originalAfterPrint(); } catch (_) {}
        cleanup();
        cw.onafterprint = null;
      };

      // Trigger print popup
      cw.focus();
      cw.print();
    };
  } catch (e) {
    console.error('PDF generation error', e);
  } finally {
    // Restore container
    if (printParent && prev) {
      printParent.style.position = prev.position;
      printParent.style.top = prev.top;
      printParent.style.left = prev.left;
      printParent.style.width = prev.width;
      printParent.style.maxHeight = prev.maxHeight;
      printParent.style.overflow = prev.overflow;
      printParent.style.opacity = prev.opacity;
      printParent.style.zIndex = prev.zIndex;
    }
  }
}


const receiptPrintClick = async () => {
  dispatch(setBillLoading(true));
  try {
    
    // Check if receiptData exists and matches current order
    await ensureReceiptDataLoaded(orderIdForPos);

    console.log("Printing receipt with data:", receiptData);
    
    // Force template remount with new key
    setPrintKey(Date.now());
    
    // Wait for remount and rendering to complete (poll DOM to ensure content exists)
    let domAttempts = 0;
    while (domAttempts < 20) {
      await new Promise(resolve => setTimeout(resolve, 150));
      const hasContent = !!(invoicePrint.current && invoicePrint.current.querySelector('.pos-receipt-template-container'));
      if (hasContent) break;
      domAttempts++;
    }
    
    let printSettingsString=localStorage.getItem('PrinterSettings')
    let printSettings=JSON.parse(printSettingsString)

    // Get company logo - use cached version in offline mode
    let companyLogo = null;
    let logoDataUrl = null;
    if (companyProfileData?.logo) {
      try {
        // Try to get from cache first (works offline)
        const cachedBlob = await db.getCachedImage(companyProfileData.logo);
        if (cachedBlob) {
          companyLogo = cachedBlob;
          // Convert to data URL for template display
          logoDataUrl = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(cachedBlob);
          });
          console.log('✅ Using cached logo (data URL) for receipt');
        } else {
          // Fallback to fetching (online only)
          companyLogo = await urlToBlob(companyProfileData.logo);
          console.log('✅ Fetched logo from URL for receipt');
        }
      } catch (error) {
        console.warn('Could not load logo for receipt:', error);
        // Continue without logo
      }
    }
    
    // Temporarily store logo data URL for template to use
    if (logoDataUrl) {
      window.__receiptLogoDataUrl = logoDataUrl;
    } else {
      delete window.__receiptLogoDataUrl;
    }
    const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(receiptData?.db)}&vendororcusid=${encodeURIComponent(receiptData?.cusId)}&type=${encodeURIComponent("POS")}&orderId=${encodeURIComponent(receiptData?._id)}`;

    const formData = new FormData();
    formData.append('printerName',printSettings?.receiptPrinter);
    formData.append('printerWidth',printSettings?.receiptSize==="80"?48:32);
    formData.append('_id',receiptData?._id);
    formData.append('customerName', JSON.stringify(receiptData?.customerName));
    formData.append('cusId', receiptData?.cusId);
    formData.append('cashier', receiptData?.cashier || "");
    formData.append('waiterName', receiptData?.waiterName || "");
    formData.append('tables', JSON.stringify(receiptData?.tables));
    formData.append('name', receiptData?.name);
    formData.append('orderDate', receiptData?.orderDate);
    formData.append('ordType', receiptData?.ordType);
    formData.append('roundOff', receiptData?.roundOff?.toFixed(decimalPosition) || 0.00);
    formData.append('totalExclusive', receiptData?.totalExclusive?.toFixed(decimalPosition));
    formData.append('totalInclusive', receiptData?.totalInclusive?.toFixed(decimalPosition));
    formData.append('amtTotal', receiptData?.amtTotal?.toFixed(decimalPosition));
    formData.append('discountAmt', receiptData?.discountAmt?.toFixed(decimalPosition));
    formData.append('taxableAmt', receiptData?.taxableAmt?.toFixed(decimalPosition));
    formData.append('orderInfo', JSON.stringify(receiptData?.orderInfo));
    formData.append('paymentInfo', JSON.stringify(receiptData?.paymentInfo));
    formData.append('kotInfo', JSON.stringify(receiptData?.kotInfo));
    formData.append('template', posTemplateSelected?.posReceiptTemplate || "");
    formData.append('contactNumber', receiptData?.contactNumber || "");
    formData.append('address', receiptData?.address || "");
    formData.append('nativeAddress', receiptData?.nativeAddress || "");
    formData.append('trnNumber', receiptData?.trnNumber || "");
    formData.append('email', receiptData?.email ||"");
    formData.append('taxDetails', JSON.stringify(receiptData?.taxDetails));
    formData.append('logoFile', companyLogo || null);
    formData.append('companyName', receiptData?.nameOfStore || "###");
    formData.append('invoiceUrl', domainAddress || window.location.host);
    formData.append('mode', printSettings?.receiptImgMode || 1);
    formData.append('logoHeight', printSettings?.logoHeight || 20);
    formData.append('deliveryCharge', Number(receiptData?.deliveryCharge)?.toFixed(decimalPosition) || 0.00);
    formData.append('amoutInWords', numToWords(Number(receiptData?.amtTotal?.toFixed(decimalPosition))));
    formData.append('enableBarcode', printSettings?.enableBarcode || false);
    formData.append('enableQrCode', printSettings?.enableQrCode || false);
    formData.append('enableNativeName', printSettings?.enableNativeName || false);
    formData.append('fontFamily', localStorage.getItem('posReceiptFont') || 'Arial');

    // Priority: Socket Print > Thermal utility > Browser print > Manual print dialog
    setTimeout(async () => {
      if (printSettings?.useSocketPrint && printSettings?.receiptPrinter) {
        // Socket Print mode - direct ESC/POS thermal print (clear text, zero margin)
        console.log('Using Socket Print (ESC/POS) for silent receipt print...');
        try {
          const { socketThermalPrint } = await import('../../../Settings/Device Settings/socketPrintService');
          await socketThermalPrint({
            printerName: printSettings?.receiptPrinter,
            printerWidth: printSettings?.receiptSize === "80" ? 48 : 32,
            template: localStorage.getItem('posReceiptTemplate') || '1',
            logoBase64: logoDataUrl || null,
            logoWidth: printSettings?.logoWidth || 320,
            companyName: receiptData?.nameOfStore || "",
            invoiceUrl: domainAddress || window.location.host,
            address: receiptData?.address || "",
            name: receiptData?.name,
            customerName: receiptData?.customerName,
            tables: receiptData?.tables,
            orderInfo: receiptData?.orderInfo,
            taxableAmt: receiptData?.taxableAmt || 0,
            taxDetails: receiptData?.taxDetails,
            amtTotal: receiptData?.amtTotal || 0,
            ordType: receiptData?.ordType,
            orderDate: receiptData?.orderDate,
            waiterName: receiptData?.waiterName || "",
            cashier: receiptData?.cashier || "",
            amoutInWords: numToWords(Number(receiptData?.amtTotal?.toFixed(decimalPosition))),
            paymentInfo: receiptData?.paymentInfo,
            deliveryCharge: Number(receiptData?.deliveryCharge) > 0 ? Number(receiptData?.deliveryCharge).toFixed(decimalPosition) : null,
            packagingCharge: Number(receiptData?.pkgCharge) > 0 ? Number(receiptData?.pkgCharge).toFixed(decimalPosition) : null,
            email: receiptData?.email || "",
            trnNumber: receiptData?.trnNumber || "",
            contactNumber: receiptData?.contactNumber || "",
            kotInfo: receiptData?.kotInfo,
            footerMsg: branchSettingsView?.termsAndCondition || receiptData?.termsAndConditions || "",
            mode: printSettings?.receiptImgMode || 1,
            logoHeight: printSettings?.logoHeight || 20,
            enableBarcode: printSettings?.enableBarcode || false,
            enableQrCode: printSettings?.enableQrCode || false,
            enableNativeName: printSettings?.enableNativeName || false,
            noOfCopies: 1,
            isQuickBill: receiptData?.isQuickBill || false,
            roundOff: receiptData?.roundOff || 0,
          });
        } catch (socketErr) {
          console.error('Socket print failed, falling back to thermal utility:', socketErr);
          printRequestAPICall(formData, posReceiptPrint);
        }
      } else if (printSettings?.receiptPrinter) {
        // Printer selected - use thermal print utility (localhost:5000)
        console.log('Using thermal print utility for receipt...');
        printRequestAPICall(formData, posReceiptPrint);
      } else if (printSettings?.useBrowserPrint) {
        // No printer selected but browser print enabled - use browser default
        console.log('Using browser print with default printer...');
        posReceiptPrint();
      } else {
        // No printer configured and no browser print - show print dialog
        console.log('No printer configured, using browser print dialog...');
        posReceiptPrint();
      }
    }, 100);

  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    dispatch(setBillLoading(false));
  }
};

// const receiptPrintClick = async () => {
//   dispatch(setBillLoading(true));
//   try {
//     const receiptHTML = invoicePrint.current;
//     // Get the height of the content
//     const contentHeight = receiptHTML.offsetHeight;
//     // Get the PPI (Pixels Per Inch) of the current screen
//     const ppi = getPPI();
//     // Convert inches to mm for jsPDF
//     const pixelsToMM = (pixels) => pixels * (25.4 / ppi);
//     const contentHeightInMM = pixelsToMM(contentHeight);
    
//     let printSettingsString=localStorage.getItem('PrinterSettings')
//     let printSettings=JSON.parse(printSettingsString)

//     const opt = {
//       margin: 0,
//       filename: 'receipt.pdf',
//       html2canvas: { scale: 4, useCORS: true }, 
//       jsPDF: { unit: 'mm', format: [Number(printSettings?.receiptSize || 80), contentHeightInMM*1.2] } 
//     };
//     // Convert to PDF
//     const pdfBlob = await html2pdf().from(receiptHTML).set(opt).outputPdf('blob');
    
    

//     const formData = new FormData();
//     formData.append('pdfFile', pdfBlob);
//     formData.append('printer_name',printSettings?.receiptPrinter);

//     printRequestAPICall(formData,posReceiptPrint)
//   } catch (error) {
//     console.error("Error generating PDF:", error);
//   } finally {
//     dispatch(setBillLoading(false));
//   }
// };
// cancel ongoing orders
const cancelOngoingOrder=(status)=>()=>{
  let payload={
    orderId:orderIdForPos,
    branchId:userInfo?.branchPk,
    password:authPassWord
  }

  let postFn=()=>{
    dispatch(setApplyBtnClicked("clicked"))
  }
if(dialogOpen==="cancelAuthPassword" || !(branchConfigurationList?.cancelOrdAuth)){
    Swal.fire({
      text:"Confirm to cancel this order",
      icon: 'warning',
      confirmButtonColor: '#f80000',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'back',
      customClass:{
        cancelButton:'sweet-alert-cancel-button',
        confirmButton:'sweet-alert-submit-button',
      },
      showCancelButton: true,
      reverseButtons: true
    }).then((result)=>{
      if(result.isConfirmed){
        if(status==="DRAFT"){
          cancelOngoingOrderApiCall(payload,postFn)
        }else{
          deleteBookingOrder(payload,postFn)
        }
      }
   })
}else{
  dispatch(setDialogBox("cancelAuthPassword"))
}
 
}

// Cancel all ongoing orders - called from button click
const cancelAllOngoingOrders = () => {
  if (heldOrders.length === 0) {
    dispatch(setSnackMsg("No orders to cancel"));
    dispatch(setErrorSnack(true));
    return;
  }

  // If auth is required, open auth dialog first
  if (branchConfigurationList?.cancelOrdAuth) {
    dispatch(setDialogBox("cancelAllAuthPassword"));
  } else {
    // No auth required, show confirmation directly
    showCancelAllConfirmation();
  }
};

// Show confirmation and execute cancel all - called after auth or directly if no auth
const showCancelAllConfirmation = () => {
  let postFn = () => {
    dispatch(setApplyBtnClicked("clicked"));
  };

  Swal.fire({
    text: `Confirm to cancel all ${heldOrders.length} ongoing orders?`,
    icon: 'warning',
    confirmButtonColor: '#f80000',
    confirmButtonText: 'Cancel All',
    cancelButtonText: 'Back',
    customClass: {
      cancelButton: 'sweet-alert-cancel-button',
      confirmButton: 'sweet-alert-submit-button',
    },
    showCancelButton: true,
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      cancelAllOngoingOrdersApiCall(heldOrders, userInfo?.branchPk, authPassWord, postFn);
    }
  });
};

useEffect(()=>{
  calculateAndSetCalculatedValues()
},[isCartModified])

useEffect(()=>{
  if(singleOrderInfo!==null){
    let updatedCartItems=singleOrderInfo?.orderInfo?.map((obj)=>({
      ...obj,
      qty:obj?.qty-obj?.retQty,
      originalQty:obj?.qty,
      retQty:(obj?.qty-obj?.retQty===0)?obj?.retQty:0
    }))
    setCartItems(updatedCartItems)
    console.log(updatedCartItems,"updatedCartItems")
  }else{
    // Only clear cartItems if it's not already empty to prevent loop
    setCartItems(prev => prev.length > 0 ? [] : prev)
  }
},[singleOrderInfo])
useEffect(()=>{
  // Only update refs if cartItems actually changed
  if (cartItems.length > 0 || qtyViewOrderRefs.current.length !== cartItems.length) {
    qtyViewOrderRefs.current = cartItems.map(() => React.createRef());
    priceViewOrderRefs.current = cartItems.map(() => React.createRef());
  }
},[cartItems])

useEffect(()=>{
  let status=[]
  if(btnClicked==="viewOrder"){
    setGridView(false)
    // Sort by latest orderDate (and orderTime) first
    const toTime = (row) => {
      // Handle Date objects from IndexedDB - convert to string
      let orderDateStr = row?.orderDate;
      if (orderDateStr instanceof Date) {
        orderDateStr = orderDateStr.toISOString();
      } else if (typeof orderDateStr !== 'string') {
        orderDateStr = orderDateStr ? String(orderDateStr) : '';
      }
      const dateStr = orderDateStr ? (orderDateStr.includes(':') ? orderDateStr : `${orderDateStr}${row?.orderTime ? ` ${row.orderTime}` : ''}`) : '';
      if (!dateStr) return 0;
      const iso = dateStr.includes(' ') ? dateStr.replace(' ', 'T') : dateStr;
      const t = new Date(iso).getTime();
      return isNaN(t) ? 0 : t;
    };
    const sorted = (ordersList || []).slice().sort((a,b) => toTime(b) - toTime(a));
    setOrderHistory(sorted)
    status=["COMPLETED","RETURN","CANCEL"]
  }else{
    // Sort held orders as well by latest first
    const toTime = (row) => {
      // Handle Date objects from IndexedDB - convert to string
      let orderDateStr = row?.orderDate;
      if (orderDateStr instanceof Date) {
        orderDateStr = orderDateStr.toISOString();
      } else if (typeof orderDateStr !== 'string') {
        orderDateStr = orderDateStr ? String(orderDateStr) : '';
      }
      const dateStr = orderDateStr ? (orderDateStr.includes(':') ? orderDateStr : `${orderDateStr}${row?.orderTime ? ` ${row.orderTime}` : ''}`) : '';
      if (!dateStr) return 0;
      const iso = dateStr.includes(' ') ? dateStr.replace(' ', 'T') : dateStr;
      const t = new Date(iso).getTime();
      return isNaN(t) ? 0 : t;
    };
    const sorted = (heldOrders || []).slice().sort((a,b) => toTime(b) - toTime(a));
    setOrderHistory(sorted)
    status=["BOOKING","DRAFT"]
  }
  dispatch(setOrderIdInPOS(null))
  dispatch(setStatusOptions(status))
  setSelectedCartRow(null)
  setInputSelection(null)
},[btnClicked,heldOrders,ordersList])

useEffect(()=>{
  if(applyBtnClicked==="clicked"){

        let status=filteredStatus==="COMPLETED"?"DONE":filteredStatus==="CANCEL"?"CANCELLED":filteredStatus 
        let payload={
          branchId:userInfo?.branchPk,
          type:btnClicked==="viewOrder"?2:1,
          search:searchBarInput,
          ordType:filteredOrderType,
          status:status==="BOOKING"?"CHDRAFT":status
        }
        btnClicked==="viewOrder"?listOrdersForBillingAPI(payload):listHeldOrders(payload)
        dispatch(setOrderIdInPOS(null))
        dispatch(setApplyBtnClicked(false))
    }
},[applyBtnClicked,searchBarInput])

// Refresh order list when offline sync completes
useEffect(() => {
  const handleSyncComplete = () => {
    console.log('🔄 Sync complete - refreshing order list');
    let status = filteredStatus === "COMPLETED" ? "DONE" : filteredStatus === "CANCEL" ? "CANCELLED" : filteredStatus;
    let payload = {
      branchId: userInfo?.branchPk,
      type: btnClicked === "viewOrder" ? 2 : 1,
      search: searchBarInput,
      ordType: filteredOrderType,
      status: status === "BOOKING" ? "CHDRAFT" : status
    };
    btnClicked === "viewOrder" ? listOrdersForBillingAPI(payload) : listHeldOrders(payload);
  };

  window.addEventListener('offlineSyncComplete', handleSyncComplete);
  return () => window.removeEventListener('offlineSyncComplete', handleSyncComplete);
}, [btnClicked, filteredStatus, filteredOrderType, searchBarInput, userInfo?.branchPk]);

useEffect(()=>{
  if(pagination===true){
    let status=filteredStatus==="COMPLETED"?"DONE":filteredStatus 
    let payload={
      branchId:userInfo?.branchPk,
      type:btnClicked==="viewOrder"?2:1,
      index:btnClicked==="viewOrder"?pageIndex:0,
      status
    }
    listOrdersPaginationAPI(payload)
    dispatch(setOrderIdInPOS(null))
  }
},[pagination])

// Timer disabled - currentTime is not used in the component
// useEffect(() => {
//   if (btnClicked === 'heldOrder') {
//     const intervalId = setInterval(() => {
//       setCurrentTime(new Date());  // Update time every second
//     }, 1000);

//     return () => clearInterval(intervalId);  // Clean up on component unmount
//   }
// }, []);

  return (
    <div className='billing-main-container'>
        <div className="billing-left-container">

          <div className="flex-row" style={{gap:"5px"}}>
              <div className='justify-center' style={{backgroundColor:"#fff",width:"40px"}}>
                  <IconButton
                    onClick={()=>{
                      dispatch(setOrderIdInPOS(null))
                      dispatch(setSingleOrderInfo(null))
                      dispatch(setCustomer(null))
                      dispatch(setBtnSelected(null))
                      }}
                    >
                      <HomeIcon sx={{ color: "green" }} />
                  </IconButton>
              </div>
              <TopBar />
          </div>

          <div className="billing-payment-ctn">
            <div className="billing-payment-ctn-left" style={{height: "calc(100vh - 120px)",maxHeight:"fit-content"}}>
            <div className="justify-space-between" style={{ padding: "0 1%" }}>
              <h4>{btnClicked === "heldOrder" ? "Ongoing Orders" : "View Orders"}</h4>
              <div className="justify-center reservation-top-right">
                {
                  btnClicked === "heldOrder" &&
                  <div
                    className="new-billing-order-type-switch"
                    style={{width:"auto"}}
                  >
                    {
                      switchTabs?.map((option) => (
                        <div
                          key={option}
                          className={`switch-bill-type ${billTypeOption === option ? 'active' : ''}`}
                          onClick={onChangeBillType(option)}
                          style={{paddingBottom:billTypeOption === option ?0:"4px"}}
                        >
                          <p readOnly style={{ margin: "0", fontSize: "0.9rem" }}>
                            {option}
                          </p>
                        </div>
                      ))
                    }
                  </div>
                }
                <FilterButton />

                {
                btnClicked==="heldOrder" &&  
                <>
                <KOTorders/>
                <button
                  onClick={cancelAllOngoingOrders}
                  className="btn-red-outlined"
                  style={{
                    padding: "4px 12px",
                    fontSize: "0.8rem",
                    borderRadius: "4px",
                    cursor: heldOrders.length === 0 ? "not-allowed" : "pointer",
                    opacity: heldOrders.length === 0 ? 0.5 : 1
                  }}
                  disabled={heldOrders.length === 0}
                >
                  Cancel All
                </button>
                <input
                  className="toggle-checkbox"
                  type={"checkbox"}
                  checked={gridView}
                  onChange={(e)=>setGridView(e.target.checked)}
                  name="gridView"
                  />
                  </>
                  }

              </div>
            </div>
                {
                gridView?<HeldOrderGridView/>:  
                <div 
                style={{maxHeight:"90vh"}}
                className="payment-view-order-table new-global-table-container"
                onScroll={handleScroll}
                >
                    
                <table>
                    <thead>
                        <tr>
                            <th style={{ paddingLeft: "15px" }}>No</th>
                            <th>Date & Time</th>
                            <Tooltip title="Order Number">
                              <th>O/No</th>
                            </Tooltip>
                            {
                              billTypeOption==="All" &&
                              
                              <Tooltip title="Order Type">
                                <th>O/Type</th>
                              </Tooltip>
                              }
                           {
                           btnClicked==="heldOrder"&& 
                           (billTypeOption==="All"|| billTypeOption==="Dine In") &&
                           <th>Table</th>}
                            <th>Customer</th>
                            {
                              btnClicked==="viewOrder" &&
                              <th>Mobile</th>
                            }
                            {
                              (billTypeOption==="Delivery" || billTypeOption==="All" || btnClicked==="viewOrder") &&
                              <>
                              <th>Address</th>
                                <th>Aggregator</th>
                                <th>Del. Charge</th>
                                <th>KM</th>
                                <th>Delivery Boy</th>
                              </>
                              }
                            <th>Amount</th>
                            {
                              btnClicked==="viewOrder" &&
                            <th>Balance</th>
                            }
                            {
                              btnClicked==="heldOrder" &&
                              <th>Timer</th>
                            }
                            {
                          (btnClicked==="viewOrder" || (billTypeOption==="All"|| billTypeOption==="Dine In")) &&
                            <th>Waiter</th>}
                            <th>Status</th>
                            {
                              btnClicked==="viewOrder" && <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                          tableLoading?
                          (
                            [...Array(10)].map((r, i) => (
                              <tr key={i}>
                                <td colSpan={13}>
                                  <Skeleton
                                    variant="rectangular"
                                    animation="wave"
                                    width={"100%"}
                                    height={40}
                                  />
                                </td>
                              </tr>
                            ))
                          ):

                          orderHistory.length!==0?
                          orderHistory?.map((r,i)=>(
                                <tr 
                                key={i}
                                onClick={viewOrderSingleClick(r)}
                                >
                                    <td style={{paddingLeft:"15px"}}>{i+1}</td>
                                    <td>
                                        {convertMonthFormat(r?.orderDate)}
                                        {r?.orderTime && (
                                          <span style={{marginLeft: '5px', color: '#666', fontSize: '12px'}}>
                                            {(() => {
                                              // Convert 24h to 12h format with AM/PM
                                              const timeParts = r.orderTime.split(':');
                                              if (timeParts.length >= 2) {
                                                let hours = parseInt(timeParts[0], 10);
                                                const minutes = timeParts[1];
                                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                                hours = hours % 12 || 12;
                                                return `${hours}:${minutes} ${ampm}`;
                                              }
                                              return r.orderTime;
                                            })()}
                                          </span>
                                        )}
                                      </td>
                                    <td>{r?.name}</td>
                                    { 
                                    billTypeOption==="All" &&
                                    <td>{r?.ordType}</td>
                                    }
                                    {
                                      btnClicked==="heldOrder"&&
                                      (billTypeOption==="All"|| billTypeOption==="Dine In") &&
                                      <td>
                                      {
                                        r.tableNames?.length !== 0 ?
                                        <>
                                        {r.tableNames?.map((tableName, index) => (
                                            <span key={index}>
                                                {index===0 && r.tableNames.length-1 >0 && "("}
                                                {tableName}
                                                {index !== r.tableNames.length - 1 && ","}
                                                {index === r.tableNames.length - 1 && r.tableNames.length-1 >0 && ")"}

                                                {/* {item.chairId.length!==0 && `CH${item.chairId.length}`} */}
                                            </span>
                                        ))}
                                        {/* {
                                            r.tableNames.length>2 &&
                                        <br />} */}
                                        <span>

                                        {r.chairId?.length !== 0 &&
                                            `/CH-${r.chairId?.length}`}
                                            </span>
                                        </>
                                          : <span>Not selected</span>
                                      }  
                                      </td>}
                                    <td>{r?.customerName}</td>
                                    {
                                      btnClicked === "viewOrder" &&
                                      <td>{r?.customerMobile || "-NIL-"}</td>
                                    }
                                    {
                                      (billTypeOption === "Delivery" || billTypeOption === "All" || btnClicked==="viewOrder") &&
                                      <>
                                  <td style={{ maxWidth: "150px" }}>
                                    {r?.ordType === "DELIVERY" ? (
                                      <>
                                        {Object.keys(r?.custAddress || {}).map((key, index, keys) => (
                                          <>
                                            {r?.custAddress[key]}
                                            {r?.custAddress[key] && index < keys.length - 1 && ", "}
                                          </>
                                        ))}
                                        {Object.values(r?.custAddress || {}).every(val => !val) && "-NIL-"}
                                      </>
                                    ) : "-"}
                                  </td>
                                        <td>{r?.ordType === "DELIVERY" ? (r?.aggregatorName || "-NIL-") : "-"}</td>
                                        <td>{r?.ordType === "DELIVERY" && r?.deliveryCharge ? Number(r?.deliveryCharge).toFixed(decimalPosition) : "-"}</td>
                                        <td>{r?.ordType === "DELIVERY" && r?.selfDeliveryKm ? Number(r?.selfDeliveryKm).toFixed(1) : "-"}</td>
                                        <td>{r?.ordType === "DELIVERY" ? (r?.deliveryBoyName || "-") : "-"}</td>
                                      </>
                                    }
                                    <td>{r?.amtTotal?.toFixed(decimalPosition)}</td>
                                    {
                                      btnClicked === "viewOrder" &&
                                      <td>
                                        <span className={r?.amountDue>0?"amount-due":""}>
                                          {r?.amountDue?.toFixed(decimalPosition)}
                                        </span>
                                        </td>}
                                    {
                                      btnClicked === "heldOrder" &&
                                      <td><TimerColumn startTime={
                                        (() => {
                                          if (r?.status === "CHDRAFT") return false;
                                          const od = r?.orderDate instanceof Date ? r.orderDate.toISOString() : (r?.orderDate ? String(r.orderDate) : '');
                                          const dateTime = od.includes(':') ? od : `${od} ${r?.orderTime || ''}`;
                                          return dateTime.trim() || false;
                                        })()
                                      } /></td>
                                    }
                                    {
                            
                           (btnClicked==="viewOrder" || (billTypeOption==="All"|| billTypeOption==="Dine In")) &&
                                    <td>{r?.waiterName || "-NIL-"}</td>}

                                    <td className="table-data-box">
                                      {r?.status === "DRAFT" ? (
                                        <span className="draft">&nbsp;&nbsp; DRAFT&nbsp;&nbsp; </span>
                                      ) : (r?.status === "POSTED" || r?.status === "DONE") ? (
                                        <span className="post"> COMPLETED</span>
                                      ) : r?.status === "CANCELLED" ? (
                                        <span className="cancel">&nbsp;&nbsp;CANCEL&nbsp;&nbsp;</span>
                                      ) : r?.status === "RETURN" ? (
                                        <span className="return">&nbsp;&nbsp;RETURN&nbsp;&nbsp;</span>
                                      ) : r?.status === "CHDRAFT" ? (
                                        <span className="requested">BOOKING</span>
                                      ) :(
                                        <span>{r?.status}</span>
                                      )}
                                    </td>
                                    {
                                      btnClicked==="viewOrder" && 
                                      <td>
                                        <IconButton
                                        onClick={singleViewOrderGeneral(r)}
                                        >
                                          <VisibilityIcon style={{color: (r?.status === "POSTED" || r?.status === "DONE")?"#9ee694":"#ccc"}}/>
                                        </IconButton>
                                      </td>
                                    }
                                </tr>
                                
                            )):
                            <tr>
                              <td colSpan={btnClicked==="heldOrder"?15:20}>No Records</td>
                            </tr>
                        }
                        {
                          paginationLoading &&
                          <tr>
                            <td style={{height:"15px"}} colSpan={19}>
                              <LinearLoading />
                            </td>
                          </tr>
                         }
                    </tbody>
                </table>
                </div>}
            </div>
          </div>
        </div>
        { 
        orderIdForPos&&
        <div className="flex-column">
          {orderIdForPos&&
            <div className="cart-table-top" style={{height:"40px"}}>
            <p>{singleOrderInfo?.ordType}</p>
            <p>{singleOrderInfo?.name || "Order ###"}</p>
            
           {

           <div className='justify-center' style={{marginLeft:"auto",gap:"5px"}}>
            {/* <Tooltip title="Send reciept as whatsapp message">

            <IconButton
              onClick={() => sendMessageToWs()}
              sx={{backgroundColor:"transparent !important"}}
              >
              <WhatsAppIcon color="success" />
            </IconButton>
              </Tooltip> */}

            <IconButton
              onClick={() => openReceiptPreview()}
              className="invoice-print-btn"
              sx={{
                backgroundColor: "transparent !important",
              }}>
              <PrintOutlined
                className="print-icon"
                sx={{ color: "#000" }}
              />
            </IconButton>
            </div>}
          </div>
          }
      
          <div
            className="billing-rightside-container"
            style={{ height: "84vh" }}
          >
           <div className="billing-right-card">

              {
              cartItems.length==0?
                <div className="billing-card-content" style={{backgroundColor:"transparent",boxShadow:"none"}}>
                  <img style={{width:"100%"}} src={emptyOrderImg} alt="" />
                </div>
              :cartItems.map((cartItem, index) => (
                <React.Fragment key={cartItem._id || index}>
                {
                  cartLoading?
                  [...Array(5)].map((r, i) =>
                  <div
                  key={i}
                  className="billing-card-content" style={{ justifyContent: "center" }}>
                    <Skeleton  width={"95%"} height="50px" />
                  </div>
                )
                :
                <div className="billing-card-content"
                style={{paddingRight:"10px",border:selectedCartRow===index && "2px solid #088051"}}
                onClick={()=>disableCompleteOrder && cartItem?.qty!==0 && cartRowClick(index)}
                >
                  <div className="billing-card-image">
                    <img src={dummyProductItemImg} alt="" />
                  </div>
                  <div className="billing-card-details">
                    <h1>{cartItem.desccription}</h1>
                    <p>{cartItem.customerNote}</p>
                  </div>
                  <div className="cart-buttons-ctn" style={{gap:"5px"}}>
                      <input 
                       type="number" 
                       value={cartItem.qty}
                       readOnly
                      />
                     {
                     disableCompleteOrder&&
                     <input 
                       ref={qtyViewOrderRefs.current[index]}
                       onClick={(e)=>{inputSelection==="qty" && selectedCartRow===index&&  e.stopPropagation()}}
                       type="number" 
                       value={cartItem.retQty || ""}
                       placeholder='0'
                       style={{border:cartItem?.qty>0 && "1px solid #f31704",color:cartItem?.qty===0 && "red",fontWeight:cartItem?.qty===0 && "600"}}
                       onChange={cartQuantityChange(index,"retQty")}
                       readOnly={selectedCartRow!==index || inputSelection!=="qty" || cartItem?.qty===0}
                      />}
                  </div>
                  <div className="billing-cart-total-price"

                  style={{ fontSize: "0.8rem" }}>
                    <p>
                    {currencyDetails?.symbol} {cartItem?.subTotalWoTax}
                    </p>
                    <p className="sub">
                    {currencyDetails?.symbol} 
                      <input 
                        type="number" 
                        ref={priceViewOrderRefs.current[index]}
                        onClick={(e)=>{selectedCartRow===index && disableCompleteOrder && e.stopPropagation()}}
                        style={{width:`${String(cartItem?.unitPrice).length * 9}px`,
                                border:(selectedCartRow===index && disableCompleteOrder) && "1px solid #088051",
                                marginLeft:(selectedCartRow===index && disableCompleteOrder) && "5px",
                                minWidth:"20px",
                                textAlign:"end"
                              }}
                        onChange={cartQuantityChange(index,"unitPrice")}
                        value={cartItem?.unitPrice}
                        readOnly={selectedCartRow!==index || !disableCompleteOrder}
                        onFocus={(e)=>e.target.select()}
                        />
                    </p>
                  </div>
                </div>
                 }
                </React.Fragment>
              ))
              }

            </div>
            
            <div style={{display:"flex",flexDirection:"column"}}>
            <div className="subtotal-amount-ctn" style={{marginBottom:"0",borderBottom:"0"}}>
              <p>Subtotal</p>
              <input 
              type="text" 
              value={`${currencyDetails?.symbol} 
              ${(btnClicked==="viewOrder" ?
              returnQtyOrderInfo?.reduce(
                (sum,item)=>sum + -(item?.lineTotal),
                0
                )
                :singleOrderInfo?.subTotal?.toFixed(decimalPosition)) ||
                 "0.00"
                 }`}
                  readOnly />
            </div>
            <div className="subtotal-amount-ctn" style={{marginTop:"0",borderTop:"0",paddingTop:"0"}}>
              <p>Amount Due</p>
              <input type="text" value={`${currencyDetails?.symbol} ${singleOrderInfo?.amountDue?.toFixed(decimalPosition) || "0.00"}`} readOnly />
            </div>
            <div className="billing-keypad-section">
                <div className="billing-input-section">
                  <div className="row">
                    <button onClick={() => handleButtonClick('7')}>7</button>
                    <button onClick={() => handleButtonClick('8')}>8</button>
                    <button onClick={() => handleButtonClick('9')}>9</button>
                  </div>
                  <div className="row">
                    <button onClick={() => handleButtonClick('4')}>4</button>
                    <button onClick={() => handleButtonClick('5')}>5</button>
                    <button onClick={() => handleButtonClick('6')}>6</button>
                  </div>
                  <div className="row">
                    <button onClick={() => handleButtonClick('1')}>1</button>
                    <button onClick={() => handleButtonClick('2')}>2</button>
                    <button onClick={() => handleButtonClick('3')}>3</button>
                  </div>
                  <div className="row">
                    <button onClick={() => handleButtonClick('.')}>.</button>
                    <button onClick={() => handleButtonClick('0')}>0</button>
                    <button 
                    onClick={keyPadBacksPace}
                    className='justify-center'><BackspaceIcon/></button>
                  </div>
                  <div className="row">
                    {inputSelection === "note" ?
                      <button
                        onClick={()=>keyPadTypeSelection(null)}
                      className="keypad-qty-btn closekey-pad-btn"
                      style={{backgroundColor:"#478045"}}
                      >
                        <DoneOutlineIcon />
                      </button> :
                      <button
                      disabled={selectedCartRow===null}
                        onClick={()=>keyPadTypeSelection("note")}
                        className={`${selectedCartRow===null? "keypad-qty-btn-enable":""} keypad-qty-btn`} 
                        >Note</button>
                    }
                    {inputSelection === "qty" ?
                      <button
                      disabled={selectedCartRow===null}
                        onClick={()=>keyPadTypeSelection(null)}
                      className="keypad-qty-btn closekey-pad-btn"
                      style={{backgroundColor:"#478045"}}
                      >
                        <DoneOutlineIcon />
                      </button> :
                      <button
                      onClick={()=>keyPadTypeSelection("qty")}
                      disabled={selectedCartRow===null}
                      className={`${selectedCartRow===null? "keypad-qty-btn-enable":""} keypad-qty-btn`} >Qty</button>

                    }
                    {inputSelection === "price" ?
                      <button
                        onClick={()=>keyPadTypeSelection(null)}
                      className="keypad-qty-btn closekey-pad-btn"
                      style={{backgroundColor:"#478045"}}
                      >
                        <DoneOutlineIcon />
                      </button> :
                      <button
                        onClick={()=>keyPadTypeSelection("price")}
                        disabled={selectedCartRow===null}
                        className={`${selectedCartRow===null? "keypad-qty-btn-enable":""} keypad-qty-btn`} 

                        >Price</button>
                    }
                  </div>
                </div>
                <div className="billing-keypad-buttons">
                    {
                      btnClicked==="heldOrder"?
                      <button
                        style={{height:"73.333px" }}
                        onClick={cancelOngoingOrder(singleOrderInfo?.status)}
                        className={`billing-clear-button`}>
                        CANCEL</button>
                      :<button
                        style={{height:"73.333px" }}
                        disabled={!disableCompleteOrder}
                        onClick={clickRefund}
                        className={`billing-clear-button ${!disableCompleteOrder?"disabled-refund":""}`}>
                        Refund</button>}
                    <button
                      className={`billing-payment-button ${!(singleOrderInfo?.status==="DRAFT" || singleOrderInfo?.status==="CHDRAFT" || singleOrderInfo?.ordStatus==="PENDING" || btnClicked==="viewOrder")?"disabled-order":""}`}
                      style={{height:"73.333px" }}
                      disabled={!(singleOrderInfo?.status==="DRAFT" || singleOrderInfo?.status==="CHDRAFT" || singleOrderInfo?.ordStatus==="PENDING" || btnClicked==="viewOrder")}
                      onClick={viewOrderUpdateOrder}
                    >{btnClicked==="heldOrder"?"Update Order":"Add Order"}</button>
                    <button
                      onClick={finalPlaceOrder}
                      className={`billing-placeOrder-button ${((singleOrderInfo?.amountDue===0) ||singleOrderInfo?.status==="CHDRAFT"|| singleOrderInfo?.status==="CANCELLED")?"disabled-payment":""}`}
                      style={{height:"73.333px" }}
                      disabled={(singleOrderInfo?.amountDue===0) || singleOrderInfo?.status==="CHDRAFT" || singleOrderInfo?.status==="CANCELLED"}
                      >Payment</button>
                </div>
            </div>

            </div>
          </div>
        
      
        </div>}


        <div className='receipt-print-parent'>
          <div ref={invoicePrint} className='pos-print-container'>
              <PosReceiptTemplate key={printKey} />
            </div>
        </div>

      <Dialog open={receiptPreviewOpen} maxWidth="lg" onClose={() => setReceiptPreviewOpen(false)}>
        <div className="billing-parent-wrapper">
          <div>
            <PosReceiptTemplate key={printKey} />
          </div>
          <div className="invoice-print-icon-container" id="invoicePrintIcon">
            <IconButton
              onClick={() => receiptPrintClick()}
              className="invoice-print-btn"
              sx={{
                backgroundColor: "#d3e3ec",
              }}>
              <PrintOutlined
                className="print-icon"
                sx={{ color: "#000" }}
              />
            </IconButton>
          </div>
        </div>
      </Dialog>


      <Dialog open={dialogOpen === "cancelAuthPassword"} onClose={() => dispatch(setDialogBox(false))}>
        <UpdateOrderAuth text={"Cancel Order"} authType="orderCancel" submitClick={cancelOngoingOrder(singleOrderInfo?.status)} />
      </Dialog>

      <Dialog open={dialogOpen === "cancelAllAuthPassword"} onClose={() => dispatch(setDialogBox(false))}>
        <UpdateOrderAuth text={"Cancel All Orders"} authType="orderCancel" submitClick={showCancelAllConfirmation} />
      </Dialog>

      <Dialog open={Boolean(viewOrderSingleId)} onClose={()=>setViewOrderSingleId(false)} maxWidth="lg" fullWidth>
        <PosOrdersHeader singleId={viewOrderSingleId} />
      </Dialog>
    </div>
  )
}

export default ViewOrders